import useWorkspaceApiCall from "hooks/useWorkspaceApiCall";
import { getNodeFileList } from "api/services/node-service";
import { useCallback } from "react";
import { IGetNodeFileListRequest } from "api/models/request/IGetNodeFileListRequest";
import { FileFlat } from "models/FileFlat";
import { ResourceType } from "models/ResourceType";

export const useGetNodeFileList = () => {
    const {
        callAPI,
        loading
    } = useWorkspaceApiCall<IGetNodeFileListRequest, FileFlat[]>(getNodeFileList, '', 'getNodeFileList.error');

    const fetchNodeFileList = useCallback(async (editor: any, resourceType: ResourceType) => {
        const response = await callAPI({ resourceType: resourceType });

        if (response?.success) {
            editor.storage.setNodeFiles(resourceType, response.data);
        }

        return response;
    }, [callAPI])

    return { fetchNodeFileList, isLoading: loading };
}